webpackJsonp(["conditioner34"],{

/***/ "./src/js/components/scroll.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = scroll;
/* harmony export (immutable) */ __webpack_exports__["scrollTo"] = scrollTo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_compute_scroll_into_view__ = __webpack_require__("./node_modules/compute-scroll-into-view/es/index.js");


var FOCUSABLE_SELECTOR = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

function matches($el, selector) {
  if ($el.matches) {
    return $el.matches(selector);
  } else if ($el.msMatchesSelector) {
    return $el.msMatchesSelector(selector);
  } else if ($el.webkitMatchesSelector) {
    return $el.webkitMatchesSelector(selector);
  }
}

function scroll($el) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$scrollMode = _ref.scrollMode,
      scrollMode = _ref$scrollMode === undefined ? 'if-needed' : _ref$scrollMode,
      _ref$block = _ref.block,
      block = _ref$block === undefined ? 'start' : _ref$block,
      _ref$inline = _ref.inline,
      inline = _ref$inline === undefined ? 'nearest' : _ref$inline,
      _ref$offset = _ref.offset,
      offset = _ref$offset === undefined ? 0 : _ref$offset,
      _ref$smooth = _ref.smooth,
      smooth = _ref$smooth === undefined ? 'true' : _ref$smooth,
      _ref$history = _ref.history,
      history = _ref$history === undefined ? 'none' : _ref$history;

  function onClick(e) {
    e.preventDefault();
    var href = $el.getAttribute('href');
    scrollTo(href, {
      scrollMode: scrollMode,
      block: block,
      inline: inline,
      offset: offset,
      smooth: smooth,
      history: history
    });
  }

  function onChange() {
    if ($el.value) {
      scrollTo('#' + $el.value, {
        scrollMode: scrollMode,
        block: block,
        inline: inline,
        offset: offset,
        smooth: smooth,
        history: history
      });
    }
  }

  if ($el.tagName === 'SELECT') {
    $el.addEventListener('change', onChange);
    return function () {
      return $el.removeEventListener('change', onChange);
    };
  }
  $el.addEventListener('click', onClick);
  return function () {
    return $el.removeEventListener('click', onClick);
  };
}

function scrollTo(href) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$scrollMode = _ref2.scrollMode,
      scrollMode = _ref2$scrollMode === undefined ? 'if-needed' : _ref2$scrollMode,
      _ref2$block = _ref2.block,
      block = _ref2$block === undefined ? 'start' : _ref2$block,
      _ref2$inline = _ref2.inline,
      inline = _ref2$inline === undefined ? 'nearest' : _ref2$inline,
      _ref2$offset = _ref2.offset,
      offset = _ref2$offset === undefined ? 0 : _ref2$offset,
      _ref2$smooth = _ref2.smooth,
      smooth = _ref2$smooth === undefined ? 'true' : _ref2$smooth,
      _ref2$history = _ref2.history,
      history = _ref2$history === undefined ? 'none' : _ref2$history;

  var $target = typeof href === 'string' ? document.querySelector(href) : href;

  if (!$target) {
    throw new Error('Couldn\u2019t find element for href ' + href);
  }

  var reduceMotion = 'matchMedia' in window && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var behavior = smooth === 'true' && !reduceMotion ? 'smooth' : 'auto';

  if (history !== 'none') {
    window.history[history + 'State']({}, '', href);
  }

  var actions = Object(__WEBPACK_IMPORTED_MODULE_0_compute_scroll_into_view__["a" /* default */])($target, {
    scrollMode: scrollMode,
    block: block,
    inline: inline
  });

  if (actions.length) {
    var $offset = document.querySelector('[data-scroll-offset]');
    if ($offset) offset += $offset.offsetHeight;
  }

  var $$focusable = matches($target, FOCUSABLE_SELECTOR) ? [$target] : $target.querySelectorAll(FOCUSABLE_SELECTOR);

  if ($$focusable.length) {
    actions.forEach(function (action) {
      action.originalTop = action.el.scrollTop;
      action.originalLeft = action.el.scrollLeft;
    });

    $$focusable[0].focus();

    actions.forEach(function (_ref3) {
      var $el = _ref3.el,
          originalTop = _ref3.originalTop;

      $el.scrollTop = originalTop;
    });
  }

  actions.forEach(function (_ref4) {
    var $el = _ref4.el,
        top = _ref4.top,
        left = _ref4.left;

    try {
      $el.scroll({
        top: top - offset,
        left: left,
        behavior: behavior
      });
    } catch (_) {
      $el.scrollTop = top - offset;
      $el.scrollLeft = left;
    }
  });
}

/***/ })

});


// WEBPACK FOOTER //
// conditioner34.71de77683bc1b9571381.js